/**
 * Used to identify the reporting mode of the settlement obligation which is either preliminary or final
 * tag: 1159
 * @readonly
 * @enum {number} (int)
 */
export enum SettlObligMode {
  /** Preliminary */
  Preliminary = 1,
  /** Final */
  Final = 2,
}
